export default __webpack_public_path__ + "static/media/bg.970bc1fb.webp";